<script>
import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Module9Item',
  props: {
    memo: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor }
}
</script>

<template>
  <div class="item" :class="{'large-item': size === 'large'}" :style="{boxShadow: `0 4px 15px 0 ${getShadowColor(path)}`}">
    <div class="memo-box">
      <p class="item-content" :class="{'speia': memo.length > 80}">{{ memo || '' }}</p>
    </div>
    <p class="item-name">——{{ name || '' }}</p>
  </div>
</template>

<style lang="scss" scoped>
.item {
  width: 196px;
  height: 325px;
  background: url('~imgs/modules/id-30-bg.png') no-repeat center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 5px;
  box-sizing: border-box;
  .item-name {
    height: 285px;
    width: 30px;
    text-align: end;
    writing-mode: vertical-lr;
    font-size: 16px;
    font-family: siyuansong;
    font-weight: 800;
    color: #CC0A66;
    letter-spacing: 2px;
    margin-left: 6px;
  }
  .memo-box {
    width: 160px;
    height: 255px;
    display: flex;
    justify-content: center;
    overflow: scroll;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }
  .item-content {
    // width: 100%;
    height: 100%;
    font-size: 11px;
    font-weight: bold;
    color: #000;
    writing-mode: vertical-lr;
    letter-spacing: 1px;
    margin-left: 14px;
    text-align: start;
  }
  .speia {
    width: 100%;
  }
}

.large-item {
  width: 224px;
  height: 377px;
  .item-name {
    height: 295px;
    font-size: 20px;
  }
  .memo-box {
    width: 160px;
    height: 285px;
    display: flex;
    justify-content: center;
  }
  .item-content {
    font-size: 14px;
    height: 100%;

    font-weight: bold;
    color: #000;
    writing-mode: vertical-lr;
    letter-spacing: 1px;
    margin-left: 14px;
  }
}
</style>
